import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" id=\"copy\"><path d=\"M11.724.75h-9.93C.882.75.137 1.425.137 2.25v10.5h1.655V2.25h9.931V.75Zm2.483 3H5.103c-.91 0-1.655.675-1.655 1.5v10.5c0 .825.745 1.5 1.655 1.5h9.104c.91 0 1.655-.675 1.655-1.5V5.25c0-.825-.745-1.5-1.655-1.5Zm0 12H5.103V5.25h9.104v10.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol